import React from 'react';
import { connect } from 'react-redux';
import DictionaryFieldCards from '../../fields/containers/DictionaryFieldCards';
import DictionaryDataUpload from './DictionaryDataUpload';
import DictionaryDescription from './DictionaryDescription';
import { datasetPermissions } from '../../sharing/constants';
import DatasetDictionaryHeader from './DatasetDictionaryHeader';
import DictionaryUploadMessage from '../components/DictionaryUploadMessage';
import { resolveCatalogueTemplate } from '../../catalogue/helper';
import { datasetPerms } from '../../sharing/state/state';
import { datasourceIngestEnabled } from '../../datasource/helper';

const DatasetDictionaryCompact = ({
  category,
  code,
  canUpload,
  uploadMessages,
  uploadMessagesError,
}) => (
  <div className="aridhia-dataset-dictionary compact">
    <DatasetDictionaryHeader code={code} category={category} compact />
    <div className="w-100">
      <DictionaryDescription code={code} category={category} />
      {uploadMessages && (
        <DictionaryUploadMessage messages={uploadMessages} error={uploadMessagesError} compact />
      )}
    </div>
    {canUpload && (
    <div className="bg-tableBg border-a border--black">
      <DictionaryDataUpload category={category} code={code} />
    </div>
    )}
    <DictionaryFieldCards category={category} code={code} />
  </div>
);

const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { upload } } } },
  catalogues: { templates },
  datasets: { datasets },
  datasetDatasource: { features },
}, ownProps) => {
  const { dataset, datasourceFeatures } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    isEditing: false,
    permissions: datasetPerms(),
    dictionaries: [],
  }, features);

  const supportsDataIngest = datasourceIngestEnabled(datasourceFeatures);

  return (
    {
      canUpload: upload
        && dataset.permissions[datasetPermissions.INGEST_DATA]
        && dataset.dictionaries.length > 0
        && supportsDataIngest
        && !dataset.isEditing,
      uploadMessages: dataset.dictionaryUploadMessages,
      uploadMessagesError: dataset.dictionaryUploadMessagesError,
    }
  );
};

export default connect(mapStateToProps)(DatasetDictionaryCompact);
